<template>
        <Teleport to="body">
        <div v-if="open" class="cgu-popup" role="dialog" aria-modal="true" aria-labelledby="cgu-popup-title">
            <div class="cgu-popup__backdrop" @click="close" />
            <div class="cgu-popup__panel">
                <button
                    v-if="!required"
                    type="button"
                    class="cgu-popup__close"
                    aria-label="Fermer"
                    @click="close"
                >
                        ×
                    </button>

                <p class="cgu-popup__eyebrow">Conditions générales d’utilisation</p>

                <div class="cgu-popup__scroll">
                    <!-- <p class="cgu-popup__text">
                        Les présentes Conditions Générales d’Utilisation (ci-après les « CGU ») ont pour objet de
                        définir les modalités et conditions dans lesquelles les utilisateurs accèdent à l’application
                        PATRIMONEA et l’utilisent, éditée par patrimonea by Gwem (ci-après « PBG »), 
                    </p> -->
                    <!-- <div class="cgu-popup__more-actions">
                        <button type="button" class="cgu-popup__more" @click="expanded = !expanded">
                            {{ expanded ? 'Réduire' : 'En savoir plus' }}
                        </button>
                        <a v-if="officialUrl" :href="officialUrl" target="_blank" rel="noopener noreferrer"
                            class="cgu-popup__official">
                            Document (PDF)
                        </a>
                    </div> -->

                    <!-- <div v-if="expanded" class="cgu-popup__extra">
                        <p>une
                        SAS au Capital de 10 000 000, filiale du Groupe GABRIEL WEALTH MANAGEMENT, dont
                        le siège social est situé à Abidjan Plateau, Avenue Dr Crozet, 6ᵉ étage, immeuble XL,
                        immatriculée au Registre du Commerce de Côte d’Ivoire (RCCM) sous le numéro CI-ABJ-03-
                        2026-B16-00048, et représentée par Madame Orphée MONNET KEBE en sa qualité de
                        Présidente.</p>
                        <h3><strong>Article 1 — Définitions</strong></h3>
                        <ul>
                            <li>Application : l’application numérique PATRIMONEA.</li>
                            <li>Utilisateur : toute personne disposant d’un compte actif.</li>
                            <li>Client : utilisateur ayant souscrit au service d’analyse patrimoniale et de conseils.
                            </li>
                            <li>Contenus : ensemble des données, analyses, recommandations, rapports et
                                informations accessibles via l’application.</li>
                        </ul>
                        <h3><strong>Article 2 – Objet de l’application</strong></h3>
                        <p>
                            L’application PATRIMONEA a pour objet de permettre aux utilisateurs :
                        </p>
                        <ul>
                            <li>De renseigner leur situation personnelle, financière et patrimoniale ;</li>
                            <li>De transmettre des documents justificatifs ;</li>
                            <li>D’accéder à une analyse patrimoniale et à des recommandations formulées par
                                patrimonea by Gwem.</li>
                        </ul>
                        <p>L’application constitue un outil d’aide à la décision patrimoniale.</p>
                        <h3><strong>Article 3 — Accès à l’application</strong></h3>
                        <p>
                            L’accès à l’application est réservé aux utilisateurs disposant d’un compte personnel.
                            L’utilisateur s’engage à fournir des informations exactes lors de la création de son compte
                            et à
                            les maintenir à jour.
                        </p>
                        <h3><strong>Article 4 — Création et gestion du compte</strong></h3>
                        <p>
                            Chaque utilisateur dispose d’identifiants strictement personnels.<br>
                            L’utilisateur est seul responsable de l’utilisation de son compte et de la confidentialité
                            de ses
                            identifiants.<br>
                            patrimonea by Gwem, assure l’anonymisation des données du client dès renseignement
                            sur la plateforme afin de renforcer leur confidentialité vis-à-vis des tiers le cas
                            échéant.<br>
                            Toute utilisation frauduleuse de ses données et notée par l’utilisateur, devra être signalée
                            sans
                            délai à patrimonea by Gwem.<br>
                        </p>
                        <h3><strong>Article 5 — Utilisation conforme de l’application</strong></h3>
                        <p>L’utilisateur s’engage à utiliser l’application :</p>
                        <ul>
                            <li>Conformément à sa destination ;</li>
                            <li>Dans le respect des lois et règlements en vigueur ;</li>
                            <li>Sans porter atteinte aux droits de patrimonea by Gwem ou de tiers.</li>
                        </ul>
                        <p>Il est notamment interdit de :</p>
                        <ul>
                            <li>Détourner l’application de son usage patrimonial ;</li>
                            <li>Tenter d’accéder aux systèmes internes ;</li>
                            <li>Extraire, copier ou diffuser les contenus sans autorisation.</li>
                        </ul>
                        <h3><strong>Article 6 — Nature des contenus et recommandations</strong></h3>
                        <p>
                            Les contenus et recommandations accessibles via l’application :
                        </p>
                        <ul>
                            <li>Sont fournis à titre informatif et patrimonial ;</li>
                            <li>Reposent sur les informations communiquées par l’utilisateur ;</li>
                            <li>Ne constituent ni des ordres d’investissement ni une garantie de performance.</li>
                        </ul>
                        <h3><strong>Article 7 — Absence de gestion et de garantie</strong></h3>
                        <p>
                            L’application ne fournit aucun service de gestion discrétionnaire.<br>
                            L’utilisateur demeure seul responsable des décisions patrimoniales qu’il prend sur la base
                            des
                            recommandations.<br>
                            patrimonea by Gwem ne garantit aucun rendement ni résultat financier.
                        </p>
                        <h3><strong>Article 8 — Sécurité et disponibilité</strong></h3>
                        <p>
                            patrimonea by Gwem met en œuvre des moyens raisonnables pour assurer la sécurité et
                            la disponibilité de l’application.<br>
                            Toutefois, l’application peut faire l’objet d’interruptions temporaires pour maintenance ou
                            raisons techniques.
                        </p>
                        <h3><strong>Article 9 — Protection des données personnelles</strong></h3>
                        <p>
                            Les données personnelles traitées dans le cadre de l’application font l’objet d’une
                            Politique de
                            confidentialité distincte, acceptée par l’utilisateur.<br>
                            patrimonea by Gwem s’engage à assurer la confidentialité et la sécurité des données
                            patrimoniales confiées.
                        </p>
                        <h3><strong>Article 10 — Propriété intellectuelle</strong></h3>
                        <p>
                            L’application, ses fonctionnalités, contenus, méthodes d’analyse et éléments graphiques sont
                            protégés par des droits de propriété intellectuelle.<br>
                            Toute reproduction ou utilisation non autorisée est interdite.
                        </p>
                        <h3><strong>Article 11 — Responsabilité de l’utilisateur</strong></h3>
                        <p>
                            L’utilisateur est responsable :
                        </p>
                        <ul>
                            <li>De l’exactitude des informations fournies ;</li>
                            <li>De la mise à jour de sa situation ;</li>
                            <li>De l’usage qu’il fait des recommandations.</li>
                        </ul>
                        <p>
                        Toute conséquence liée à des informations erronées ne saurait engager la responsabilité de
                        patrimonea by Gwem.
                        </p>
                        <h3><strong>Article 12 — Suspension et suppression du compte</strong></h3>
                        <p>
                            patrimonea by Gwem se réserve le droit de suspendre ou supprimer un compte en cas :
                        </p>
                        <ul>
                            <li>D'utilisation non conforme ;</li>
                            <li>De violation des CGU ;</li>
                            <li>De comportements Frauduleux ;</li>
                        </ul>
                        <h3><strong>Article 13 — Évolution de l’application et des CGU</strong></h3>
                        <p>
                            patrimonea by Gwem se réserve le droit de faire évoluer l’application et de modifier les
                            présentes CGU.
                            Toute modification substantielle sera portée à la connaissance des utilisateurs.
                        </p>
                        <h3><strong>Article 14 — Droit applicable et juridiction compétente</strong></h3>
                        <p>
                            Les présentes CGU sont soumises au droit ivoirien. <br>
                            Tout litige qui pourrait naitre de leur interprétation ou exécution sera tranchés
                            définitivement
                            par la Cour d’Arbitrage de Côte d’Ivoire (CACI)
                        </p>
                        <p class="cgu-popup__text">
                        L’utilisation de l’application implique l’acceptation pleine et entière des présentes CGU par
                        l’utilisateur.
                    </p>

                    </div> -->

                    <div class="cgu-popup__sign">
                        <!-- Signature tracée remplacée par une case à cocher (CGU = pas besoin d'une
                             preuve de consentement individualisée). Conservé en commentaire au cas où :
                        <SignatureTact document-name="Conditions générales d’utilisation" :locked="false" :busy="busy"
                            @signature-saved="onSignatureSaved" />
                        -->
                        <CheckAcceptance document-name="Conditions générales d’utilisation"
                            :locked="false" :busy="busy" @signature-saved="onSignatureSaved">
                            J’adhère aux
                            <a v-if="officialUrl" :href="officialUrl" target="_blank" rel="noopener noreferrer">conditions d’utilisation</a>
                            <a v-else href="#" @click.prevent="expanded = true">conditions d’utilisation</a>.
                        </CheckAcceptance>
                    </div>
                    </div>
                </div>
            </div>
        </Teleport>
</template>

<script>
// import SignatureTact from '@/components/shared/SignatureTact.vue'; // remplacé par CheckAcceptance
import CheckAcceptance from '@/components/shared/CheckAcceptance.vue';

export default {
    name: 'PopCGU',
    components: { CheckAcceptance },
    props: {
        open: { type: Boolean, default: false },
        officialUrl: { type: String, default: '' },
        busy: { type: Boolean, default: false },
        /** Si true : fermeture impossible tant que la signature n’est pas confirmée. */
        required: { type: Boolean, default: false },
    },
    emits: ['close', 'accepted'],
    data() {
        return {
            expanded: false,
        };
    },
    watch: {
        open(isOpen) {
            if (typeof document === 'undefined') return;
            document.body.style.overflow = isOpen ? 'hidden' : '';
            if (isOpen) this.expanded = false;
        },
    },
    beforeUnmount() {
        if (typeof document !== 'undefined') {
            document.body.style.overflow = '';
        }
    },
    methods: {
        close() {
            if (this.required) return;
            this.$emit('close');
        },
        onSignatureSaved(payload) {
            this.$emit('accepted', {
                ...payload,
                expanded: this.expanded,
                ts: Date.now(),
            });
        },
    },
};
</script>

<style scoped>
.cgu-popup {
    position: fixed;
    inset: 0;
    z-index: 11050;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 1rem;
}

.cgu-popup__backdrop {
    position: absolute;
    inset: 0;
    background: rgba(15, 23, 42, 0.58);
    backdrop-filter: blur(4px);
}

.cgu-popup__panel {
    position: relative;
    z-index: 1;
    width: min(640px, 100%);
    max-height: min(92dvh, 92vh);
    display: flex;
    flex-direction: column;
    padding: 1.35rem 1.35rem 1.1rem;
    border-radius: 20px;
    background:
        radial-gradient(circle at top right, rgba(216, 156, 36, 0.12), transparent 38%),
        #fff;
    box-shadow: 0 24px 48px rgba(15, 23, 42, 0.24);
}

.cgu-popup__close {
    position: absolute;
    top: 0.8rem;
    right: 0.9rem;
    width: 2.25rem;
    height: 2.25rem;
    border: 0;
    border-radius: 999px;
    background: rgba(15, 23, 42, 0.06);
    color: #0f172a;
    font-size: 1.35rem;
    line-height: 1;
    cursor: pointer;
}

.cgu-popup__eyebrow {
    margin: 0 0 0.35rem;
    font-size: 0.75rem;
    font-weight: 700;
    letter-spacing: 0.12em;
    text-transform: uppercase;
    color: var(--brand-brown, #8a6a1a);
}

.cgu-popup__scroll {
    overflow: auto;
    min-height: 0;
    padding-right: 0.15rem;
}

.cgu-popup__text {
    margin: 0 0 0.85rem;
    color: var(--brand-navy, #01263e);
    line-height: 1.6;
    font-size: 0.95rem;
}

.cgu-popup__more-actions {
    display: flex;
    flex-wrap: wrap;
    gap: 0.75rem;
    align-items: center;
    margin: 0 0 1rem;
}

.cgu-popup__more,
.cgu-popup__official {
    border: 0;
    background: transparent;
    color: var(--brand-navy, #01263e);
    font-weight: 700;
    font-size: 0.92rem;
    text-decoration: underline;
    cursor: pointer;
    padding: 0;
}

.cgu-popup__extra {
    margin: 0 0 1.15rem;
    padding: 0.9rem 1rem;
    border-radius: 12px;
    background: #f8fafc;
    border: 1px solid rgba(1, 38, 62, 0.08);
}

.cgu-popup__extra h3 {
    margin: 0.75rem 0 0.35rem;
    font-size: 0.95rem;
    color: var(--brand-navy, #01263e);
}

.cgu-popup__extra h3:first-child {
    margin-top: 0;
}

.cgu-popup__extra p {
    margin: 0 0 0.55rem;
    font-size: 0.9rem;
    line-height: 1.55;
    color: var(--brand-navy, #01263e);
}

.cgu-popup__extra ul {
    margin: 0 0 0.75rem;
    padding-left: 1.15rem;
    font-size: 0.9rem;
    line-height: 1.55;
    color: var(--brand-navy, #01263e);
}

.cgu-popup__sign {
    margin-top: 0.25rem;
    padding-top: 0.85rem;
    border-top: 1px solid rgba(1, 38, 62, 0.1);
}
</style>
